import { RouteConfig } from 'vue-router'

const PsychReportIndexRoute: RouteConfig = {
  path: '/activity/summer-points-2026/psych-report',
  name: 'activity_summer_points_2026_psych_report',
  component: () => import('./Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026年暑假心理健康检测',
  },
}

const PsychReportClassListRoute: RouteConfig = {
  path: '/activity/summer-points-2026/psych-report/classes',
  name: 'activity_summer_points_2026_psych_report_classes',
  component: () => import('./ClassList.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级数据',
  },
}

const PsychReportClassDetailRoute: RouteConfig = {
  path: '/activity/summer-points-2026/psych-report/class-detail',
  name: 'activity_summer_points_2026_psych_report_class_detail',
  component: () => import('./ClassDetail.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级详情',
  },
}

const PsychReportStudentListRoute: RouteConfig = {
  path: '/activity/summer-points-2026/psych-report/students',
  name: 'activity_summer_points_2026_psych_report_students',
  component: () => import('./StudentList.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '可能需要关注的学生',
  },
}

export default [
  PsychReportIndexRoute,
  PsychReportClassListRoute,
  PsychReportClassDetailRoute,
  PsychReportStudentListRoute,
]
